import doFetch from 'root/utils/cors/doFetch';
const isRetail = document.body.getAttribute('data-product');

const returnLexic = async () => {
    const lexicName = document
        .querySelector('[data-pricing-lexic-name]')
        ?.getAttribute('data-pricing-lexic-name');
    const endpoint = `/wp-json/lexic/v1/${
        lexicName ?? 'pricing_table_with_wizard/retail/'
    }`;
    const errorLogObject = {
        searchTerm: 'pricing-lexic-error',
        tags: ['pricing-page'],
        fileName: 'pricing.js',
    };
    return await doFetch(endpoint, errorLogObject);
};

if (isRetail === 'retail') {
    (async () => {
        const lexicData = await returnLexic();
        if (lexicData?.filtering.filters_available === 'on') {
            import(
                /*webpackChunkName: "[request]"*/ 'root/page/pricing/retailLocalizationPricing'
            ).then(module => module.default(lexicData).init());
        } else {
            import(
                /*webpackChunkName: "[request]"*/ 'root/page/pricing/legacyPricing.js'
            ).then(module => module.default());
        }
    })();
} else {
    import(/*webpackChunkName: "[request]"*/ 'root/page/pricing/legacyPricing.js').then(
        module => module.default()
    );
}
